import { render, staticRenderFns } from "./storePersonAdd.vue?vue&type=template&id=d0316efa&scoped=true&"
import script from "./storePersonAdd.vue?vue&type=script&lang=js&"
export * from "./storePersonAdd.vue?vue&type=script&lang=js&"
import style0 from "./storePersonAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./storePersonAdd.vue?vue&type=style&index=1&id=d0316efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0316efa",
  null
  
)

export default component.exports